import React from 'react';
import classnames from 'classnames';

import styles from './style/menu-underliner.module.css';

class MenuUnderliner extends React.Component<any, any> {
  private defaultState: object;
  private _timerRef: React.MutableRefObject<NodeJS.Timeout | null>;

  constructor(
  public props,
  public state)
  {
    super(props);
    this.defaultState = {
      left: 0,
      width: 0,
      instantaneous: true,
      mounted: false,
      hidden: false
    };
    this.state = this.defaultState;

    this._timerRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ mounted: true });

    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.forceUpdate();
  }

  componentWillUnmount() {
    this._timerRef.current && clearTimeout(this._timerRef.current);

    this.setState({ mounted: false });

    if (this.props.onRef) {
      this.props.onRef(undefined);
    }
  }

  public updateDimensions(left, width, instantaneous = false) {
    if (!this.state.mounted) return;

    this._timerRef.current = setTimeout(
      () =>
      this.setState({
        left,
        width,
        instantaneous,
        hidden: false
      }),
      0
    );
  }

  public hide() {
    if (!this.state.mounted) return;

    this.setState({
      hidden: true
    });
  }

  render() {
    const { hidden, instantaneous, left, width } = this.state;
    const { extendClass } = this.props;

    const growProportion = (width | 0) / 100;

    return (
      <div className={`${styles.underlineContainer} ${extendClass || ''}`}>
				<div
          className={classnames(
            styles.underline,
            instantaneous ? '' : styles.withTransition
          )}
          style={{
            transform: `translateZ(0) translateX(${
            left + 50 * growProportion - 50 | 0}px) scaleX(${
            growProportion})`,
            display: hidden ? 'none' : 'block'
          }} />

			</div>);

  }
}

export default MenuUnderliner;